import { useApi } from '@/api';
import { KpiCard, KpiSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Flex, PercentageValue } from '@blockanalitica/ui';

export default function ExposureKpis({ daysAgo }) {
  const [data, error] = useApi({
    url: '/groups/core/exposure/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <Flex flexDirection="column" gap="m">
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <Flex flexBasis="33%">
            <KpiCard
              title="ETH Exposure"
              data={data}
              field="eth_exposure"
              options={{
                valueOptions: {
                  currencyValueOptions: {
                    currency: tokensMapping('DAI'),
                    iconSize: '3',
                    notation: 'compact'
                  }
                }
              }}
              extra={<CryptoIcon name="WETH" size="5" />}
              footer={
                <Flex gap="3xs">
                  <PercentageValue value={data.eth_exposure / data.debt} />
                  of total debt
                </Flex>
              }
            />
          </Flex>
          <Flex flexBasis="33%">
            <KpiCard
              title="WBTC Exposure"
              data={data}
              field="wbtc_exposure"
              options={{
                valueOptions: {
                  currencyValueOptions: {
                    currency: tokensMapping('DAI'),
                    iconSize: '3',
                    notation: 'compact'
                  }
                }
              }}
              extra={<CryptoIcon name="WBTC" size="5" />}
              footer={
                <Flex gap="3xs">
                  <PercentageValue value={data.wbtc_exposure / data.debt} />
                  of total debt
                </Flex>
              }
            />
          </Flex>
          <Flex flexBasis="33%">
            <KpiCard
              title="stETH Exposure"
              data={data}
              field="steth_exposure"
              options={{
                valueOptions: {
                  currencyValueOptions: {
                    currency: tokensMapping('DAI'),
                    iconSize: '3',
                    notation: 'compact'
                  }
                }
              }}
              extra={<CryptoIcon name="wstETH" size="5" />}
              footer={
                <Flex gap="3xs">
                  <PercentageValue value={data.steth_exposure / data.debt} />
                  of total debt
                </Flex>
              }
            />
          </Flex>
        </Flex>
      </Flex>
    );
  }

  return (
    <>
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <KpiSkeleton />
        <KpiSkeleton />
      </Flex>
    </>
  );
}
